module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Reinach_BL-2f9986249b906c14fa5e301aa62d1f52.svg";